import { AddressChange, DateChange, PhoneChange, TextChange } from './fields';

const RenderFieldsList: Record<string, (props) => JSX.Element> = {
	firstName: TextChange,
	lastName: TextChange,
	businessName: TextChange,
	businessAddress: AddressChange,
	businessRole: TextChange,
	email: TextChange,
	mobile: PhoneChange,
	phone: PhoneChange,
	dateOfBirth: DateChange,
	Address: AddressChange,
	title: TextChange,
	preferredName: TextChange,
	otherNames: TextChange
};

export function getRenderField(name: string) {
	return RenderFieldsList[name];
}
